/**
 * BeBobi — przy zmianie KOLORU w pickerze Horizon (strona produktu i okno szybkiego dodawania):
 * jeśli wybrany rozmiar (lub inna widoczna opcja) nie jest zamawialny w nowym kolorze, przełącz na
 * pierwszy zamawialny wariant tego koloru — tak jak spotlight (assets/bebobi-spotlight.js, syncSelection).
 * Zamawialny = variant.available (w stanie, bez śledzenia lub "kontynuuj sprzedaż").
 *
 * Działa w fazie capture na document, więc PRZED variant-picker.js: zaznacza właściwe radio przez
 * publiczne updateSelectedOption(), a Horizon buduje zapytanie (option_values) już z nowym rozmiarem.
 * Ukryte opcje (Zestaw: Osobno/W komplecie) są stałe — nigdy nie przełącza na "W komplecie".
 * Dane: <script data-bb-variants> i fieldset[data-bb-color] z snippets/variant-main-picker.liquid.
 * Gdy kolor nie ma żadnego zamawialnego wariantu — nic nie zmienia (przycisk pokaże "Wyprzedane").
 */
function bbControls(picker) {
  /** @type {Map<number, {el: HTMLElement, hidden: boolean, color: boolean}>} */
  const map = new Map();
  for (const fs of picker.querySelectorAll('fieldset[data-fieldset-index]')) {
    const i = Number(fs.getAttribute('data-fieldset-index'));
    map.set(i, { el: fs, hidden: fs.hidden, color: fs.hasAttribute('data-bb-color') });
  }
  for (const sel of picker.querySelectorAll('select[data-bb-option-index]')) {
    const i = Number(sel.getAttribute('data-bb-option-index'));
    if (!map.has(i)) map.set(i, { el: sel, hidden: false, color: false });
  }
  return map;
}

function bbSelectedValue(ctl) {
  if (ctl.el instanceof HTMLSelectElement) return ctl.el.value;
  const checked = ctl.el.querySelector('input:checked');
  return checked ? checked.value : null;
}

document.addEventListener(
  'change',
  (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
    if (!input.closest('fieldset[data-bb-color]')) return;
    const picker = input.closest('variant-picker');
    const raw = picker && picker.querySelector('script[data-bb-variants]');
    if (!picker || !raw) return;
    // Dean 14.10.2026: na produktach z fitterem aut rozmiar klienta jest stały — bez przełączania
    // (snippets/variant-main-picker.liquid ustawia data-bb-fitter-gate; kolor wyszarzony, wybór = "Wyprzedane")
    if (picker.hasAttribute('data-bb-fitter-gate')) return;

    let variants;
    try { variants = JSON.parse(raw.textContent || '[]'); } catch (_) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    const controls = bbControls(picker);
    const colorIdx = Number(input.closest('fieldset').getAttribute('data-fieldset-index'));
    const selected = [];
    for (const [i, ctl] of controls) selected[i] = i === colorIdx ? input.value : bbSelectedValue(ctl);

    const exact = variants.find((v) => v.options.every((o, i) => selected[i] == null || o === selected[i]));
    if (exact && exact.available) return; // obecny rozmiar jest zamawialny w nowym kolorze

    const fixed = [...controls].filter(([i, c]) => i !== colorIdx && c.hidden).map(([i]) => i);
    const adjustable = [...controls].filter(([i, c]) => i !== colorIdx && !c.hidden && !c.color).map(([i]) => i);
    const alt = variants.find((v) => v.available
      && v.options[colorIdx] === input.value
      && fixed.every((i) => v.options[i] === selected[i]));
    if (!alt) return; // kolor wyprzedany we wszystkich rozmiarach — zostaje "Wyprzedane"

    for (const i of adjustable) {
      if (alt.options[i] === selected[i]) continue;
      const ctl = controls.get(i);
      if (ctl.el instanceof HTMLSelectElement) {
        ctl.el.value = alt.options[i];
        picker.updateSelectedOption?.(ctl.el);
      } else {
        const radio = [...ctl.el.querySelectorAll('input')].find((r) => r.value === alt.options[i]);
        if (radio) picker.updateSelectedOption?.(radio);
      }
    }
    // URL ?variant= w variant-picker.js bierze data-variant-id klikniętego koloru
    input.dataset.variantId = String(alt.id);
  },
  true
);
